/**
 * 辅材管理 接口
 */
 import axios from '../request';
 export default{
    /**
     * 辅材种类
     */
    // 查询辅材种类信息
    searchAuxiliaryType: params =>
        axios.post('/materials/assist/assistList', params),
    // 添加辅材种类信息
    insertAuxiliaryType: params =>
        axios.post('/materials/assist/assistInsert', params),
    // 修改辅材种类信息
    updateAuxiliaryType: params =>
        axios.post('/materials/assist/assistUpdate', params),
    // 辅材种类信息详情
    detailsAuxiliaryType: params =>
        axios.get('/materials/assist/assistInfo', {params}),
    // 删除辅材种类信息
    deleteAuxiliaryType: params =>
        axios.get('/materials/assist/assistDel', {params}),

    /**
     * 入库记录
     */
    // 查询入库记录信息
    searchAuxiliaryIncome: params =>
        axios.post('/materials/assistRecord/assistRecordList', params),
    // 添加入库记录信息
    insertAuxiliaryIncome: params =>
        axios.post('/materials/assistRecord/assistRecordInsert', params),
    // // 修改入库记录信息
    // updateAuxiliaryIncome: params =>
    //     axios.post('/assist/assistUpdate', params),
    // 入库记录信息详情
    detailsAuxiliaryIncome: params =>
        axios.get('/materials/assistRecord/assistRecordInfo', {params}),
    // 删除入库记录信息
    deleteAuxiliaryIncome: params =>
        axios.post('/materials/assistRecord/assistRecordDel', params),
    //导出数据
    exportDatas:params=>
        axios({
            method: 'post',
            url: '/materials/assistRecord/assistExport',
            responseType: 'blob',
            data: params
        }),
    //导出模板
    exportIncomeFiles: params =>
        axios({
        method: 'get',
        url: '/materials/assistRecord/recordExportTemplate',
        responseType: 'blob',
        params: params
    }),
    //导入Excel
    exportIncomeDatas: params =>
        axios.post('/materials/assistRecord/assistRecordExcel', params),
    /**
     * 出库记录
     */
    // 查询出库记录信息
    searchAuxiliaryOut: params =>
        axios.post('/materials/assistRecord/assistRecordOutList', params),
    // 添加出库记录信息
    insertAuxiliaryOut: params =>
        axios.post('/materials/assistRecord/assistRecordInsert', params),
    //出库导出数据
    exportOutDatas:params=>
        axios({
            method: 'post',
            url: '/materials/assistRecord/assistOutExport',
            responseType: 'blob',
            data: params
        }),
    //删除出库记录信息
    deleteAuxiliaryOut: params =>
        axios.post('/materials/assistRecord/assistRecordDel', params),
    /**
     * 库存管理
     */
    // 库存校正
    addAuxiliaryCheck: params =>
        axios.post('/materials/assistRecord/assistCheck', params),
    //导出数据
    exportInventDatas:params=>
        axios({
            method: 'post',
            url: '/materials/assist/assistExport',
            responseType: 'blob',
            data: params
        }),
    /**
     * 校正记录
     */
    // 查询校正信息
    searchAuxiliaryCheck: params =>
        axios.post('/materials/assistRecord/assistCorrectionList', params),

 }